import React from 'react';

export default function renderNodeOrComponent(NodeOrComponent, props = {}) {
  if (React.isValidElement(NodeOrComponent)) {
    return React.cloneElement(NodeOrComponent, props);
  } else {
    return <NodeOrComponent {...props} />;
  }
}
